const CARDS_KEY = "smartgaz_cards";

export function readCards() {
  try {
    const parsed = JSON.parse(localStorage.getItem(CARDS_KEY) || "[]");
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function writeCards(cards) {
  localStorage.setItem(CARDS_KEY, JSON.stringify(cards));
}

export function addCard(card) {
  const cards = readCards();
  const next = [{ ...card, id: card.id || `${Date.now()}` }, ...cards];
  writeCards(next);
  return next;
}

